import { finallyChildrenRouterModeHandler } from '@utils/utils'

// 网球 共用
import tennisRouter from '@router/tennis/commonRouter'
// 【中国网球公开赛】
import tennisRouter_chinaOpenRouter from '@router/tennis/cup_tennisChinaOpen'

const {
  TennisScheduleIndex,
  TennisScheduleDetail,
  TennisScheduleDetailStartList,
  TennisScheduleDetailLocalData,
  TennisScheduleDetailDataAnalysis,
  TennisKnockoutRoundsIndex,
  TennisEventsThemeListIndex,
  TennisBroadcastListIndex,
  TennisDataPackagListIndex,
  TennisProgramListIndex,
} = tennisRouter

const { PlatfromTennisCupFullChinaOpen } = tennisRouter_chinaOpenRouter

const pathModuleBase = 'platfromTennisFull'
const diffCompetitionTypeArr = [
  {
    name: 'TENCO',
    pathModule: 'chinaOpen',
    component: PlatfromTennisCupFullChinaOpen,
  }, //  中网
]

const baseChildren = [
  {
    path: 'schedule', //赛程
    name: 'tennisScheduleIndex',
    component: TennisScheduleIndex,
    meta: {
      pathModule: ['tennis', 'chinaOpen', 'schedule'],
      requireLogin: false,
      title: '赛程',
    },
  },
  {
    path: 'scheduleDetail', //赛程详情
    redirect: { name: 'tennisScheduleDetailLocalData' },
    name: 'tennisScheduleDetail',
    component: TennisScheduleDetail,
    meta: {
      pathModule: ['tennis', 'chinaOpen', 'schedule'],
      requireLogin: false,
    },
    children: [
      {
        path: 'startList', //出场名单
        name: 'tennisScheduleDetailStartList',
        component: TennisScheduleDetailStartList,
        meta: {
          pathModule: ['tennis', 'chinaOpen', 'schedule'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'localData', //本场数据
        name: 'tennisScheduleDetailLocalData',
        component: TennisScheduleDetailLocalData,
        meta: {
          pathModule: ['tennis', 'chinaOpen', 'schedule'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
      {
        path: 'dataAnalysis', //数据分析
        name: 'tennisScheduleDetailDataAnalysis',
        component: TennisScheduleDetailDataAnalysis,
        meta: {
          pathModule: ['tennis', 'chinaOpen', 'schedule'],
          requireLogin: false,
          title: '项目赛果',
        },
      },
    ],
  },
  {
    path: 'knockoutRounds', //淘汰赛
    name: 'tennisKnockoutRoundsIndex',
    component: TennisKnockoutRoundsIndex,
    meta: {
      pathModule: ['tennis', 'chinaOpen', 'knockoutRounds'],
      requireLogin: false,
      title: '淘汰赛',
    },
  },
  {
    path: 'eventsThemeList', //晋级之路
    name: 'tennisEventsThemeListIndex',
    component: TennisEventsThemeListIndex,
    meta: {
      pathModule: ['tennis', 'chinaOpen', 'eventsThemeList'],
      requireLogin: false,
      title: '晋级之路',
    },
  },
  {
    path: 'broadcastList', //播出单
    name: 'tennisBroadcastListIndex',
    component: TennisBroadcastListIndex,
    meta: {
      pathModule: ['tennis', 'chinaOpen', 'broadcastList'],
      requireLogin: false,
      title: '播出单',
    },
  },
  {
    path: 'dataPackagList', //数据包装
    name: 'tennisDataPackagListIndex',
    component: TennisDataPackagListIndex,
    meta: {
      pathModule: ['tennis', 'chinaOpen', 'dataPackagList'],
      requireLogin: false,
      title: '数据包装',
    },
  },
  {
    path: 'programList', //节目单
    name: 'tennisProgramListIndex',
    component: TennisProgramListIndex,
    meta: {
      pathModule: ['tennis', 'chinaOpen', 'programList'],
      requireLogin: false,
      title: '节目单',
    },
  },
]

const finallyChildrenRouterModeArr = finallyChildrenRouterModeHandler(
  diffCompetitionTypeArr,
  baseChildren
)

console.debug(
  'finallyChildrenRouterModeArr tennis:',
  finallyChildrenRouterModeArr
)

const routerModeArr = diffCompetitionTypeArr.map((routerItem, routerIndex) => ({
  path: `/${routerItem.pathModule}`, // /chinaOpen
  name: `${pathModuleBase}_${routerItem.name}`, // platfromTennisFull_TENCO
  component: routerItem.component,
  children: finallyChildrenRouterModeArr[routerIndex],
}))

export default { compreSportsMeet_chinaOpen_RouterMode: routerModeArr[0] }
